"use client";
import React from "react";
import PatientsList from "../../components/PatientsPage/PatientsList/PatientsList";
import "./Patients.css";
import AppLayoutDoctor from "../../../navigation/Layout/LayoutDoctor";

const Patients = () => (
  <AppLayoutDoctor>
    <div className="patients-content">
      <PatientsList />
    </div>
  </AppLayoutDoctor>
);

export default Patients;